export interface HeaderConfig {
  obj_type?: string;
  name?: string;
  synonym?: string;
  presentation_field?: string;
}

export interface RecordHeader {
  title: string;
  status?: { label: string };
}

interface Opts {
  isDocument: boolean;
  recordId: string | null;
  /** Locale-resolved object synonym — always shown in the title (1C parity). */
  objectLabel: string;
}

function firstNonEmpty(data: Record<string, unknown>, keys: string[]): string | null {
  for (const k of keys) {
    const v = data[k];
    if (v !== undefined && v !== null && String(v).trim() !== '') return String(v);
  }
  return null;
}

export function deriveRecordHeader(
  config: HeaderConfig | null | undefined,
  data: Record<string, unknown>,
  opts: Opts,
): RecordHeader {
  const pf = config?.presentation_field;
  const recordPart =
    (pf ? firstNonEmpty(data, [pf]) : null) ??
    firstNonEmpty(data, ['name', 'number', 'code']);

  // One rule for every object type: "<Synonym> <record>", falling back to
  // whichever half exists (new/empty record — the object synonym alone).
  const objectLabel = opts.objectLabel || config?.synonym || config?.name || '';
  const title = [objectLabel, recordPart].filter(Boolean).join(' ');

  const status = opts.isDocument ? { label: opts.recordId ? 'Posted' : 'Draft' } : undefined;

  return { title, status };
}
